let homeVideo;
window.addEventListener('DOMContentLoaded', (event) => {
  homeVideo = document.querySelector('#home-bgvid');
  
  // if (homeVideo) {
  //   setTimeout(() => {
  //     homeVideo.pause();
  //   }, 2372)
  // }
});
  

window.addEventListener('DOMContentLoaded', (event) => {
tempCleanUpPochonAttribute();

  leftNavAccordion();
  closeLeftNav();
  openLeftNavMenu();
  mobileMenuMechanism();
  initNavAnimations();
  triggerOpenCart();
  orderNotesMechanism();
  let mm = gsap.matchMedia();
  // trigger from small desktop on up
  mm.add("(min-width: 992px)", () => {
  if (leftNavHoverTrigger !== null && leftNavHoverTrigger !== undefined) {
    initMaskHoverAnimation();
  }
    // check if we're on the full screen hero pages, then change all links to white if true
    if (fullHeroHeader !== null && fullHeroHeader !== undefined) {
      setHeroTextColor(); 
    }
  });
  
  // goBackLink();
  cookieBannerMechanism();
  weglotMechanism();
  // setHeroTextColor();
  getCart();
  // if page is Our Stores or Sust. Fashion 
  if (window.location.href.includes('nos-magasins') || window.location.href.includes('mode-durable')) {
    anchorScrollDifferentPage();
  }

  // if page is search results
  if (window.location.href.includes('search')) {
    anchorScrollDifferentPage();
  }
  passwordPageContactLink();
  focusSearchInput();
  mobileCartOffersMechanism();
  cartToggleScroll();
  toggleBodyScroll();
  restoreFirstQuickAddMobileOffers();
  scrollAjaxCartToTop();
  instagramSlider();
  cartOffersUpdateState();
  newsletterPopUp();
});


// !!!! begin side nav open/close
var headerClass = "accord-header";
const eshopHeader = document.querySelector("#eshop-header");
const leftNavHeaderLinks = document.querySelectorAll(".accord-header");
const leftNav = document.querySelector(".left-nav");
const leftNavHoverTrigger = document.querySelector("[data-left-hover-trigger]");
const topNav = document.querySelector(".nav");
const newsletterTrig = document.querySelector(".hero-newsletter-wrapper");

function leftNavAccordion() {
  $(".left-nav-links-wrap").click(function (e) {
    var target = e.target;
  
    if (
      target.classList.contains(headerClass) ||
      target.parentElement.classList.contains(headerClass)
    ) {
      var subItem = $(target).next();
      //slideUp all elements (except target) at current depth or greater
      var depth = $(subItem).parents().length;
      var allAtDepth = $(".left-nav-links-wrap .accord-content").filter(
        function () {
          if ($(this).parents().length >= depth && this !== subItem.get(0)) {
            return true;
          }
        }
      );
      $(allAtDepth).slideUp(450);
  
      //slideToggle target content and adjust bottom border if necessary
      subItem.slideToggle(450);
      if (target.classList.contains("is--open")) {
        if (target.id == "eshop-header") {
          resetAllHeaderLinks("overall");
        } else {
          resetAllHeaderLinks("inner");
        }
      } else {
        resetAllHeaderLinks("inner");
        target.classList.add("is--open");
      }
    }
  });
}

function closeLeftNav() {
  if (leftNav !== null) {
    leftNav.addEventListener("mouseleave", () => {
      // Close left nav menu if open
      if (eshopHeader.classList.contains("is--open")) {
        setTimeout(() => {
          eshopHeader.click();
        }, 500);
      }
    });
  }
}


function resetAllHeaderLinks(resetScope) {
  if (resetScope == "overall") {
    leftNavHeaderLinks.forEach((headerLink) => {
      if (headerLink.classList.contains("is--open")) {
        headerLink.classList.remove("is--open");
      }
    });
  } else if (resetScope == "inner") {
    leftNavHeaderLinks.forEach((headerLink) => {
      if (
        headerLink.classList.contains("is--open") &&
        headerLink.id != "eshop-header"
      ) {
        headerLink.classList.remove("is--open");
      }
    });
  }
}

// #################
// !!!! end side nav open/close


gsap.registerPlugin(ScrollTrigger);

// #################
// !!!! begin reduce nav on scroll

const promoBar = document.querySelector("[data-promo-bar]");
let LBGBlack = "#151515";
let navTextColorTo = LBGBlack;
let topValue = "0em";
let topNavWrapper = document.querySelector(".top-nav-wrapper");
let menuBtn = document.querySelector("[data-menu-btn]");
let menuBtnClicks = 0;

// check if nav color is supposed to be white or black, change variable to reflect it
if (topNavWrapper.classList.contains("color-white")) {
  navTextColorTo = "#ffffff";
}

// !!!! begin mobile menu mechanism
function mobileMenuMechanism() {
  menuBtn.addEventListener("click", () => {
    if (menuBtnClicks % 2 === 0) {
      let openMenu = gsap.timeline();
      openMenu
        .to(".menu-btn-line", { backgroundColor: LBGBlack, duration: 0.2 })
        .to(".nav", { color: LBGBlack, duration: 0.2 }, "<")
        .to(
          ".nav-mask",
          { height: "0%", duration: 0.8, ease: Power2.easeInOut },
          "<"
        );
    } else {
      if (window.pageYOffset === 0) {
        let closeMenu = gsap.timeline();
        closeMenu
          .to(".menu-btn-line", {
            backgroundColor: navTextColorTo,
            duration: 0.2
          })
          .to(".nav", { color: navTextColorTo, duration: 0.2 }, "<");
      } else {
        gsap.to(".nav-mask", {
          height: "100%",
          duration: 0.8,
          ease: Power2.easeInOut,
          delay: 0.6
        });
      }
    }
    menuBtnClicks++;
  });
}
// !!!! end mobile menu mechanism


function initNavAnimations() {
  ScrollTrigger.saveStyles(".top-nav-links, .nav-mask, .nav, .tb-logo-top-wrap, .menu-btn-line");
  ScrollTrigger.matchMedia({
    // desktop
    "(min-width: 992px)": function () {
      navTimelines("-1em");
    },
    // tablet
    "(max-width: 991px)": function () {
      navTimelines("0em");
    }
  });
}


function showNavTrig() {
  let navtrig = document.querySelector('.nav-trigger');
  
  navtrig.style.display = "block";
  // navtrig.style.backgroundColor = "red";
  navtrig.style.zIndex = 20;
 
  let navmask = document.querySelector('.nav-mask');
  
  navmask.style.opacity = 1;
}

showNavTrig();

function navTimelines(moveTopNavLinksBy) {
  let expandNavTl = gsap.timeline({
    paused: true,
    defaults: { ease: Power1.easeInOut, duration: 0.35 }
  }).to(".tb-logo-top-wrap", { height: "0em", duration: 0.2 })
    .to(".nav-mask", { height: "100%", duration: 2, ease: Power2.easeInOut }, "<" )
    .to(".top-nav-link.bottom-10", { opacity: 0, duration: 0.2 }, "<0.2")
    .to(".top-nav-links", { y: moveTopNavLinksBy }, "<")
    .to(".nav", { backgroundColor: "rgba(255,255,255,0)", duration: 0.2 }, "<")
    .to(".nav", { color: LBGBlack, duration: 0.2 }, "<")
    .to(".top-nav-links.top-left", {color: LBGBlack, duration: 0.2}, "<")
    .to(".menu-btn-line", { backgroundColor: LBGBlack, duration: 0.2 }, "<")
    // .to(".nav-mask", { opacity: 1, duration: 0.2 }, "<")

    ScrollTrigger.create({
      trigger: ".nav-trigger",
      // markers: { startColor: "green", endColor: "red" },
      start: "top 10px",
      onLeave: () => gsap.to(expandNavTl, { progress: 1, duration: 0.8, ease: "power2.in" }),
      onEnterBack: () => gsap.to(expandNavTl, { progress: 0, duration: 0.8, ease: "power2.out" })
    });

      
        let reduceNavTl = gsap.timeline({
          paused: true,
          defaults: { ease: Power1.easeInOut, duration: 0.35 }
        }).to(".nav-mask", { height: "0%", duration: 0.6, ease: Power2.easeInOut })
          .to(".nav", { color: navTextColorTo, duration: 0.2 }, "<0.2")
          .to(".top-nav-links.top-left", { color: navTextColorTo, duration: 0.2 }, "<")
          .to(".menu-btn-line", { backgroundColor: navTextColorTo, duration: 0.2 }, "<")
          .to(".tb-logo-top", { opacity: 1 }, "<")
          .to(".tb-logo-top-wrap", { height: "3.6em", duration: 0.2 }, "<")
          .to(".top-nav-link.bottom-10", { opacity: 1, duration: 0.2 }, "<0.2")
          .to(".top-nav-links", { y: "0em" }, "<")
          .to(".nav", { backgroundColor: "rgba(255,255,255,0)", duration: 0.2 }, "<")
          // .to(".nav-mask", { opacity: 0, duration: 0.2 })

          // ScrollTrigger.create({
          //   trigger: ".nav-trigger",
          //   // markers: { startColor: "green", endColor: "red" },
          //   start: "top 10px",
          //   onLeave: () => gsap.to(reduceNavTl, { progress: 1, duration: 1, ease: "power2.in" }),
          //   onEnterBack: () => gsap.to(reduceNavTl, { progress: 0, duration: 0.65, ease: "power2.out" })
          // });




    }


// !!!! end reduce nav on scroll

// #################
// !!!! begin side nav hover mask
let leftNavMask = document.querySelector("[data-left-nav-mask]");
let fullHeroHeader = document.querySelector('[data-full-hero]');

function initMaskHoverAnimation() {
  Observer.create({
    target: leftNavHoverTrigger, // can be any element (selector text is fine)
    type: "pointer", // comma-delimited list of what to listen for ("wheel,touch,scroll,pointer")
    onHover: () => leftNavMaskHover(),
    onHoverEnd: () => leftNavMaskHover()
  });
  
  let leftNavHoverAnimHero = gsap.timeline({reversed: true, paused: true});
  
      leftNavHoverAnimHero
      .fromTo(leftNavMask,
          {x: "-100%", duration: 0.3, ease: Power2.easeIn},
          {x: "0%", duration: 0.6, ease: Power2.easeOut})
          
          // check if we're on the full screen hero pages, then change top left link color if true
      if (fullHeroHeader !== null && fullHeroHeader !== undefined) {
        leftNavHoverAnimHero
        // .fromTo(leftNav,{ mixBlendMode: "normal", duration: 0},{ mixBlendMode: "difference", duration: 0})
        .fromTo(".side-nav-link", {color: '#fff'}, {color: '#bbb'}, "<")
        .fromTo(".top-nav-links.top-left", {color: '#fff'},{color: LBGBlack}, "<")
      }
      
      
  
    let leftNavHoverAnimBody = gsap.timeline({reversed: true, paused: true});
      
        leftNavHoverAnimBody
        .fromTo(leftNavMask,
            {x: "-100%", duration: 0.3, ease: Power2.easeIn},
            {x: "0%", duration: 0.6, ease: Power2.easeOut})
        // .fromTo(leftNav,{ mixBlendMode: "difference", duration: 0},{ mixBlendMode: "difference", duration: 0}, "<")
        .fromTo(".side-nav-link", {color: '#bbb'},{color: '#bbb'}, "<")
        .fromTo(".top-nav-links.top-left", {color: LBGBlack},{color: LBGBlack}, "<")
  

      
        

  
  function leftNavMaskHover() {
    if (leftNavHoverTrigger !== null && leftNavHoverTrigger !== undefined) {
      if (window.pageYOffset === 0) {
        // console.log(window.pageYOffset);
        leftNavHoverAnimHero.reversed() ? leftNavHoverAnimHero.play() : leftNavHoverAnimHero.reverse();
      } else {
        leftNavHoverAnimBody.reversed() ? leftNavHoverAnimBody.play() : leftNavHoverAnimBody.reverse();
        // console.log(window.pageYOffset);
      }
    }
  }
}

// #################
// !!!! end side nav hover mask



// #################
// !!!! begin cart functionality

const cartBtnUI = document.querySelector("#open-cart-btn");

const closeCartBtnUI = document.querySelector("#close-cart");
const keepShoppingBtnUI = document.querySelector("#close-cart-cta");
const closeCartWrapperUI = document.querySelector(".cart-wrapper");
const cartTriggerUI = document.querySelector("#open-cart-trigger");

function triggerOpenCart() {
  document.addEventListener("click", (e) => {
    if (e.target == cartTriggerUI || e.target.parentElement == cartTriggerUI || e.target.parentElement.parentElement == cartTriggerUI) {
      cartBtnUI.click();
    }
  });
}


function triggerCloseCart() {
  closeCartBtnUI.click();
}
// end cart functionality


// if (closeCartBtnUI !== null) {
//   closeCartBtnUI.addEventListener("click", bodyScroll);
// }
// if (closeCartWrapperUI !== null) {
//   closeCartWrapperUI.addEventListener("click", bodyScroll);
// }
if (keepShoppingBtnUI !== null) {
keepShoppingBtnUI.addEventListener("click", triggerCloseCart);
}

let innerCart = document.querySelector('[data-inner-cart]');
let cartBG = document.querySelector('[data-cart-bg]');
let enableScrollMain = document.querySelector('[data-enable-scroll=main]');

function cartToggleScroll() {

  if (cartBG !== null && cartBG !== undefined) {
    cartBG.addEventListener('click', (e) => {
    
      if (e.target !== innerCart && innerCart.contains(e.target) === false) {
        enableScrollMain.click();
      }
    })
  }
}

function toggleBodyScroll() {
  document.addEventListener('click', (e) => {
    if (e.target.parentElement !== null && e.target.parentElement !== undefined) {
      if (e.target.getAttribute('data-enable-scroll') || e.target.parentElement.getAttribute('data-enable-scroll')) {
        enableBodyScroll();
      }
      else if (e.target.getAttribute('data-disable-scroll') || e.target.parentElement.getAttribute('data-disable-scroll')) {
        disableBodyScroll();
      }
    }
  })
}

function enableBodyScroll() {
  if (document.body.classList.contains("overflow-hidden")) {
    document.body.classList.remove("overflow-hidden");
  }   
}

function disableBodyScroll() {
  if (document.body.classList.contains("overflow-hidden") === false) {
    document.body.classList.add("overflow-hidden");
  }   
}

// end body overflow scroll


// // !!!begin go back link
function goBackLink() {

  let goBackLinkElement = document.getElementById('go-back-link');
  if (goBackLinkElement !== null) {
    goBackLinkElement.addEventListener('click', (e) => {
      e.preventDefault();
      window.history.back();
    })
  }
}
// // end go back link

// #################
// !!!! begin Webflow cookie consent
var popup = document.getElementById("consentPopup");
var alreadyLoaded = window.localStorage.getItem("fbGrantConsent") === "true";
//Show the consent banner if consent is not granted, hide it if consent is already granted.

function cookieBannerMechanism() {
  if (popup !== null) {
    if (alreadyLoaded) {
      popup.style.display = "none";
      fbq("consent", "grant");
    } else {
      popup.style.display = "block";
    }
  }
  //Grant consent and store it in localStorage of the browser
  var consentBtn = document.getElementById("consentBtn");
  var consentBtnTwo = document.getElementById("consentBtn2");
  
  if (consentBtn !== null) {
    consentBtn.addEventListener("click", function () {
      fbq("consent", "grant");
      window.localStorage.setItem("fbGrantConsent", "true");
    });
  }
  
  if (consentBtnTwo !== null) {
    consentBtnTwo.addEventListener("click", function () {
      fbq("consent", "grant");
      window.localStorage.setItem("fbGrantConsent", "true");
    });
  }
}
// end Webflow cookie consent
// #################

// #################
// !!!! begin Weglot script
// init Weglot
function weglotMechanism() {
  // Weglot désactivé - utilisation des traductions natives Shopify
  // Weglot.initialize({
  //   api_key: "wg_fefe58c72d8653011f81363f920fe3d85"
  // });
  
  // on Weglot init
  // Weglot.on("initialized", () => {
  //   // get the current active language
  //   const currentLang = Weglot.getCurrentLang();
  //   // call updateDropdownLinks function
  //   updateSW5DropdownLinks(currentLang);
  //
  // });
  
  // document.addEventListener('click', (e) => {
  //   console.log(e.target.parentElement);
  // })

  // on Weglot language changed init
  // Weglot.on("languageChanged", () => {
  //   // setTimeout(() => {
  //   //   triggerOpenCart();
  //   // }, 500)
    
  // });
  
  // for each of the .wg-element-wrapper language links
  document.querySelectorAll(".wg-element-wrapper.sw5 [lang]").forEach((link) => {
    // add a click event listener
    link.addEventListener("click", function (e) {
      // prevent default
      e.preventDefault();
      // switch to the current active language
      Weglot.switchTo(this.getAttribute("lang"));
      // call updateDropdownLinks function
      updateSW5DropdownLinks(this.getAttribute("lang"));
    });
  });
  
  // updateDropdownLinks function
  function updateSW5DropdownLinks(currentLang) {
    // get the wrapper element
    const $allwrappers = document.querySelectorAll(".wg-element-wrapper.sw5");
  
    $allwrappers.forEach((weglotWrapper) => {
      // if the .w-dropdown-toggle is not the current active language
      if (
        weglotWrapper.querySelector(".w-dropdown-toggle").getAttribute("lang") !==
        currentLang
      ) {
        // get the current active language link
        const $activeLangLink = weglotWrapper.querySelector(
          "[lang=" + currentLang + "]"
        );
        // swap the dropdown toggle's text with the current active language link text
        const $toggle = $activeLangLink
          .closest(".wg-element-wrapper")
          .querySelector(".w-dropdown-toggle");
        const toggleTxt = $toggle.querySelector(".top-nav-link").textContent;
        const activeLangLinkTxt = $activeLangLink.textContent;
        $toggle.querySelector(".top-nav-link").textContent = activeLangLinkTxt;
        $activeLangLink.textContent = toggleTxt;
        // swap the dropdown toggle's lang attr with the current active language link lang attr
        const lang = $activeLangLink.getAttribute("lang");
        const toggleLang = $toggle.getAttribute("lang");
        $toggle.setAttribute("lang", lang);
        $activeLangLink.setAttribute("lang", toggleLang);
      }
    });
  }
}

// #################
// !!!! end Weglot script






function anchorScrollDifferentPage() {
    gsap.registerPlugin(ScrollToPlugin);

    
    let urlSearchParams = new URLSearchParams(window.location.search);
    let anchor = urlSearchParams.get("anchor");
    
    if (anchor) {
      setTimeout(() => {
        gsap.to(window, {duration: 2, scrollTo: {y: anchor, offsetY: 90}, ease: "power2.inOut"});
      }, 500)
    }
}

function openLeftNavMenu() {
  // if desktop
  if (window.innerWidth >= 992) {
    let LeftNavFirstItem = document.querySelector('#eshop-header');
    if (LeftNavFirstItem !== null) {
      LeftNavFirstItem.click();
    }
  }
}

function passwordPageContactLink() {
  const navContactLink = document.querySelector('[data-nav-contact-link]')
  if (window.location.href.includes('password') || window.location.href.includes('401')) {
    navContactLink.href = "mailto:info@labottegardiane.com"
  }
}

let openSearchBtn = document.querySelector('[data-open-search-btn]');
let searchInput = document.querySelector('[data-search-input]');

function focusSearchInput() {
  openSearchBtn.addEventListener('click', () => {
    setTimeout(()=>{
      searchInput.focus();
    }, 50)
  });
}




// begin mobile cart offers expand/collapse
let cartOffersTrigger = document.querySelector('[data-cart-offers-trig]');
let cartOffersWrap = document.querySelector('[data-cart-offers]');

let cartOffersPlusLine
if (cartOffersTrigger !== null && cartOffersTrigger !== undefined) {
  cartOffersPlusLine = cartOffersTrigger.querySelector('[data-cart-offers-line]');
}

function mobileCartOffersMechanism() {

  if (cartOffersPlusLine !== null && cartOffersPlusLine !== undefined) {
    gsap.set(cartOffersWrap, { height: "auto" });
  
    let mobileCartOffersAnim = gsap.timeline({reversed: true, paused: true});
    mobileCartOffersAnim
      .fromTo(
        cartOffersWrap,
        {height: "0"},
        {height: "auto", duration: 0.7, ease: Power2.inOut},"<")
      .fromTo(
        cartOffersWrap,
        {paddingBottom: "0"},
        {paddingBottom: "15", duration: 0.7, ease: Power2.inOut},"<")
      .fromTo(cartOffersPlusLine,
        { rotate: "0"},
        { rotate: "90", duration: 0.7, ease: Power2.inOut},"<");
  
    cartOffersTrigger.addEventListener('click', () => {
      mobileCartOffersAnim.reversed() ? mobileCartOffersAnim.play() : mobileCartOffersAnim.reverse();
    })
  }

}

// end mobile cart offers expand/collapse


let firstQuickAddMobile, myHiddenInputMobile;

function restoreFirstQuickAddMobileOffers() {
  
  if (firstQuickAddMobile !== null && firstQuickAddMobile !== undefined) {
    firstQuickAddMobile = cartOffersWrap.querySelectorAll('[data-atc-mobile-cart-offer]')[0];
    firstQuickAddMobile.addEventListener('click', (e) => {
      e.preventDefault();
      myHiddenInputMobile = firstQuickAddMobile.closest('[udy-el="loop-add-to-cart"]').querySelector('input[type=hidden]');
      
      let variantID = myHiddenInputMobile.value;
  
      window.location.href = `/cart/add?id=${variantID}&quantity=1`;
    });
  }
}

let ajaxCartProductList = document.querySelector('[udy-el="items-list"]');
function scrollAjaxCartToTop() {
  document.body.addEventListener('cart-should-be-updated', () => {
    ajaxCartProductList.scrollTop = 0;
  })
}


// // instagram slider
function instagramSlider() {

  let splides = $(".splide.instagram-slider");

  if (splides !== null && splides !== undefined) {
    for (let i = 0, splideLength = splides.length; i < splideLength; i++) {
      new Splide(splides[i], {
        // Desktop on down
        perPage: "auto",
        perMove: 1,
        autoplay: "play",
        focus: 'center', // 0 = left and 'center' = center
        type: "slide", // 'loop' or 'slide'
        gap: "2px", // space between slides
        arrows: false, // 'slider' or false
        pagination: false, // 'slider' or false
        speed: 1200, // transition speed in miliseconds
        dragAngleThreshold: 30, // default is 30
        breakpoints: {
          767: {
            // Mobile Landscape
            gap: "1px", // space between slides
          },
          479: {
            // Mobile Portrait
            gap: "1px", // space between slides
          }
        }
      }).mount();
    }
  }
}





function setHeroTextColor() {
  let heroTextWhite = gsap.timeline({
    defaults: { ease: Power1.easeInOut, duration: 0.8 },
    scrollTrigger: {
      trigger: ".nav-trigger",
      // markers: true,
      start: "5px 60px",
      // events: onEnter onLeave onEnterBack onLeaveBack
      toggleActions: "play reverse play reverse"
    }
  });

  heroTextWhite
  .to(".side-nav-link", {color: "#fff"})
  .to(".top-nav-links.top-left", {color: '#fff'},"<")
}




function cartOffersUpdateState() {
  document.addEventListener('click', (e) => {
    if (e.target.getAttribute('data-node-type') === 'commerce-add-to-cart-button') {
      if (cartWrapper.classList.contains('updating') === false) {
        cartWrapper.classList.add('updating');
      }
    }
    document.body.addEventListener('product-added-to-cart', () => {
      setTimeout(()=>{
        cartWrapper.classList.remove('updating');
      }, 500)
    })
  })
}


// begin newsletter pop up mechanism

let newsletterOpenTrigger = document.querySelector('[data-open-newsletter]');
let newsletterCloseTrigger = document.querySelector('[data-close-newsletter]');
let newsletterCaptureSuccess = window.location.href.includes('?customer_posted=true');
let newsletterCaptureFail = window.location.href.includes('form_type=customer#contact_form');

function newsletterPopUp() {
  afterNewsletterPosted();
}

function afterNewsletterPosted() {
  if (newsletterCaptureSuccess || newsletterCaptureFail) {
    showNewsletter(0);
    setCookie("newsletterSubscribed", "true", 1);
  }
}

function showNewsletter(timeout) {
  setTimeout(() => {
    newsletterOpenTrigger.click();
  }, timeout)
}

function hideNewsletter() {
  if (newsletterCloseTrigger) {
    newsletterCloseTrigger.click();
  }
}

// end newsletter pop up mechanism

function setCookie(name, value, days) {
  let date, expires;
  if (days) {
      date = new Date();
      date.setDate(date.getDate()+days);
      expires = "; expires="+date.toUTCString();
  } else {
      expires = "";
  }
  document.cookie = name+"="+value+expires+"; path=/";
}

// !!!! begin cotton bag checkbox script

const cartCheckboxWraps = document.querySelectorAll('.checkbox-field');
const cartCheckboxesFake = document.querySelectorAll('.checkbox-field .w-checkbox-input.w-checkbox-input--inputType-custom');
const cartCheckboxes = document.querySelectorAll('.checkbox-field [data-custom-checkbox]');
const cartWrapper = document.querySelector('[data-node-type="commerce-cart-wrapper"]');
const cartCheckboxContainers = document.querySelectorAll('[data-checkbox-container]');

document.body.addEventListener('cart-should-be-updated', () => {
  getCart();
})
  
cartCheckboxWraps.forEach(checkboxWrap => {
  checkboxWrap.addEventListener('click', () => {
    cartWrapper.classList.add('updating');
    clickUpdateCheckbox();
  });
});

function getCart() {
  fetch(window.Shopify.routes.root + 'cart.js').then(res => {
    return res.json();
  })
  .then(cart => {
    hideShowCheckbox(cart)
    loadUpdateCheckbox(cart);
  })
  .catch(error => console.log('ERROR fetching the cart'))

    
  };
      
function hideShowCheckbox(cart) {
  if (cartCheckboxContainers !== null && cartCheckboxContainers.length !== 0) {
    if (cartIncludesShoes(cart)) {
      cartCheckboxContainers.forEach(container => {
        container.classList.remove('hide');
      });
    } else {
      cartCheckboxContainers.forEach(container => {
        container.classList.add('hide');
      });
    }
  }
}

function cartIncludesShoes(cart) {
  let cartHasShoe = false;

  cart.items.forEach(item => {
    let cartItemOptions = item.options_with_values;
    cartItemOptions.forEach(cartItemOption => {
      if (cartItemOption.name === 'Pointure' || cartItemOption.name === 'pointure') {
        cartHasShoe = true
      }
    });
  });

  return cartHasShoe;
}


function loadUpdateCheckbox(cart) {
  let checkboxState = false;
    if (cart.attributes['Inclure le Pochon:'] === 'Oui') {
        cartCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        cartCheckboxesFake.forEach(checkbox => {
            checkbox.classList.remove('w--redirected-checked');
        });
        checkboxState = false;
    } else {
        cartCheckboxes.forEach(checkbox => {
            checkbox.checked = true;
        });
        cartCheckboxesFake.forEach(checkbox => {
            checkbox.classList.add('w--redirected-checked');
        });
        checkboxState = true;
    }
    
    let onLoadMessage = '';
    if (checkboxState === false) {
      onLoadMessage = `ON LOAD --> Cotton bag (Pochon) is included in the cart`
    } else {
      onLoadMessage = `ON LOAD --> Cotton bag (Pochon) is NOT included in the cart`
    }
    console.log(onLoadMessage)
};


function clickUpdateCheckbox(cart) {
  fetch(window.Shopify.routes.root + 'cart.js').then(res => {
    return res.json();
  })
  .then(cart => {
    if (cart.attributes['Inclure le Pochon:'] === 'Oui') {
      // Add/remove classes to checkbox when clicked
      cartCheckboxesFake.forEach(checkbox => {
        checkbox.classList.add('w--redirected-checked');
      });
      removeCottonBag();
  } else {
      cartCheckboxesFake.forEach(checkbox => {
        checkbox.classList.remove('w--redirected-checked');
      });
      addCottonBag();
  }
  setTimeout(() => {
    cartWrapper.classList.remove('updating');
  }, 500)
  })
  .catch(error => console.log('ERROR fetching the cart'))
};


function addCottonBag(cart) {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: { 'Inclure le Pochon:': 'Oui' }
    })
  }).then(res => {
    console.log("Cotton bag was successfully added!");
    return res.json();
  })
  .catch(error => console.log('ERROR adding the cotton bag'))
}
  
function removeCottonBag(cart) {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: { 'Inclure le Pochon:': 'Non' }
    })
  }).then(res => {
    console.log("Cotton bag was successfully removed!");
    return res.json();
  })
  .catch(error => console.log('ERROR removing the cotton bag'))
}

// END cotton bag checkbox script

// BEGIN cart order notes script
function orderNotesMechanism() {
  const openOrderNotesMainBtn = document.querySelector('[data-order-notes="main-open"]');
  const orderNotesTextArea = document.querySelector('[data-order-notes="textarea"]');
  const openOrderNotesTriggers = document.querySelectorAll('[data-order-notes="trigger-open"]');
  const saveOrderNotesTriggers = document.querySelectorAll('[data-order-notes="save"]');
  let orderNotesIsOpen = false;


  getOrderNoteAjax().then(note => {
    orderNotesTextArea.value = note;
  });  

  // Add event listeners
  openOrderNotesMainBtn.addEventListener('click', ()  => {
    if (orderNotesIsOpen === false) {
      orderNotesIsOpen = true;
    }
  })
  
  openOrderNotesTriggers.forEach(openTrigger => {
    openTrigger.addEventListener('click', ()  => {
      console.log("orderNotesIsOpen:", orderNotesIsOpen)
      cartTriggerUI.click();
      if (orderNotesIsOpen === false) {
        setTimeout(()=>{
          openOrderNotesMainBtn.click();
        }, 350)
      }
    })
  });

  saveOrderNotesTriggers.forEach(saveTrigger => {
    saveTrigger.addEventListener('click', ()  => {
      updateOrderNoteAjax();
      orderNotesIsOpen = false;
    })
  });

  function updateOrderNoteAjax() {
    const textAreaContent = orderNotesTextArea.value;
    const cartUpdateUrl = '/cart/update.js';
  
    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        note: textAreaContent
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Cart updated:', data);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
  
  function getOrderNoteAjax() {
    const cartUrl = '/cart.js';
    
    return fetch(cartUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      return data.note; // Return the fetched note
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

// END cart order notes script




function tempCleanUpPochonAttribute() {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: { 'Pochon': '' }
    })
  }).then(res => {
    console.log("Old Pochon attribute was removed!");
    return res.json();
  })
  .catch(error => console.log('ERROR removing the old Pochon attribute'))
}